module.exports = __webpack_public_path__ + "img/4-2.43a30327.png";